<template>
  <div>
    <v-select
      label="Email template"
      v-model="emailTemplateId"
      :items="emailTemplates"
      item-value="id"
      item-text="name"
      outline
    />
    <v-text-field
      label="Subject"
      v-model="subject"
      readonly
      outline
    ></v-text-field>
    <v-btn-toggle v-model="editorMode" mandatory>
      <v-btn flat small value="source">Source</v-btn>
      <v-btn flat small value="rich">Richtext</v-btn>
    </v-btn-toggle>
    <v-alert :value="editorMode == 'rich'" type="info"
      >The editor below treats blocks of text as paragraphs. So there is no need
      to add extra line breaks in between blocks of text.</v-alert
    >
    <quill-editor
      v-model="body"
      :read-only="loadingBody"
      @input="updatedBody"
      v-if="editorMode == 'rich'"
    />
    <v-textarea
      v-model="body"
      v-if="editorMode == 'source'"
      label="Enter your content"
      @input="updatedBody"
      :readonly="loadingBody"
      outline
      required
    />
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EmailTemplates",
  props: ["tag", "fileid", "entities"],
  data() {
    return {
      editorMode: "rich",
      emailTemplates: null,
      emailTemplateId: null,
      subject: null,
      body: null,
      loadingBody: false,
      timerId: null,
    };
  },
  methods: {
    async fetchEmailTemplates() {
      const response = await nbmlaw.get(
        `/cors/admin/document/emailTemplates/tags/${this.tag}`
      );
      // console.log(response.data);
      this.emailTemplates = response.data;
    },
    async fetchEmailTemplateSubject() {
      if (!this.fileid || !this.entities) {
        return;
      }
      const response = await nbmlaw.get(
        `/cors/admin/document/emailTemplates/${this.emailTemplateId}/subject/filled`,
        { params: { fileid: this.fileid, ids: this.entities } }
      );
      // console.log(response.data);
      this.subject = response.data;
    },
    async fetchEmailTemplateBody() {
      if (!this.fileid || !this.entities) {
        this.loadingBody = false;
        return;
      }
      const response = await nbmlaw.get(
        `/cors/admin/document/emailTemplates/${this.emailTemplateId}/body/${this.fileid}/${this.entities}`
      );
      // console.log(response.data);
      this.body = response.data;
      this.loadingBody = false;
    },
    updatedBody() {
      //debounce
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.emitUpdated();
      }, 500);
    },
    emitUpdated() {
      this.$emit("updated", {
        emailTemplateId: this.emailTemplateId,
        subject: this.subject,
        body: this.body,
      });
    },
  },
  watch: {
    emailTemplates: {
      handler() {
        this.emailTemplateId = this.emailTemplates.find(
          (e) => e.defaulted == true
        ).id;
      },
    },
    emailTemplateId: {
      handler() {
        const emailTemplate = this.emailTemplates.find(
          (et) => et.id == this.emailTemplateId
        );
        if (emailTemplate) {
          this.loadingBody = true;
          this.subject = emailTemplate.subject;
          this.body = emailTemplate.body;
          this.fetchEmailTemplateBody();
          this.fetchEmailTemplateSubject();
        }
      },
    },
  },
  created() {
    this.fetchEmailTemplates();
  },
};
</script>

<style>
</style>